import { Link } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { ArrowSmallRightIcon, SidebarLogoIcon, SidebarLogoTxtIcon } from '@/assets/images/icons';
import privateRoutes from '@/routes/privateRoutes';
import { useSelector } from 'react-redux';

const isDashboard = (route, isIcon) => {
    if (route.accessor === 'dashboard') {
        return isIcon ? <Link to={`/app${route.path}`}>{route.icon}</Link> : <Link to={`/app${route.path}`}>{route.name}</Link>;
    } else {
        return isIcon ? <Link to={`/app/${route.accessor}`}>{route.icon}</Link> : <Link to={`/app/${route.accessor}`}>{route.name}</Link>;
    }
};

function Sidebar({
    collapsed,
    openKeys,
    setOpenKeys,
    selectedKeys,
    setSelectedKeys,
}) {
    const userAccess = useSelector((state) => state.profile.userProfile?.permissions);

    const hasPermission = (permissions, scopeList) => {
        if (!scopeList || scopeList.length === 0) {
            return true;
        }
        return scopeList.some((scope) => permissions?.includes(scope));
    };

    // Filter sidebar items based on permissions
    const sidebarItems = privateRoutes
        .filter((route) => route.inSidebar && hasPermission(userAccess, route.permissions))
        .map((route) => ({
            key: route.key,
            icon: route.subMenus && route.subMenus.length > 0
                ? route.icon
                : isDashboard(route, true),
            label: route.subMenus && route.subMenus.length > 0
                ? route.name
                : isDashboard(route, false),
            children:
                route.subMenus?.filter((subMenu) => hasPermission(userAccess, subMenu.permissions))
                    .map((subMenu) => ({
                        key: subMenu.key,
                        icon: <ArrowSmallRightIcon />,
                        label: <Link to={`/app/${route.accessor}${subMenu.path}`}>{subMenu.name}</Link>,
                    })),
        }));

    return (
        <Layout.Sider
            trigger={null}
            collapsible
            collapsed={collapsed}
            width={290}
        >
            <div className="sidebar-logo">
                {collapsed ? <SidebarLogoIcon /> : <SidebarLogoTxtIcon />}
            </div>
            <Menu
                theme="dark"
                mode="inline"
                openKeys={openKeys}
                selectedKeys={selectedKeys}
                items={sidebarItems}
                onSelect={({ key }) => setSelectedKeys([key])}
                onOpenChange={(keys) => setOpenKeys(keys)}
            />
        </Layout.Sider>
    );
}

export default Sidebar;
